import constants from '~/utils/constants';
import type {
    RoutesDrawerSortMapMode,
    RoutesDrawerSortDirection
} from './types';

export const isValidSortMapMode = (
    mapMode: string
): mapMode is RoutesDrawerSortMapMode => {
    const validMapRouteModes: string[] = [
        constants.mapRouteModes.PLAN,
        constants.mapRouteModes.DISPATCHED,
        constants.mapRouteModes.COMPLETED
    ];

    return validMapRouteModes.includes(mapMode);
};

export const isValidSortDirection = (
    sortDirection: string
): sortDirection is RoutesDrawerSortDirection => {
    const validSortOrders: string[] = [
        constants.sortOrder.ASC,
        constants.sortOrder.DESC
    ];

    return validSortOrders.includes(sortDirection.toLowerCase());
};
